import { withCookiesRestClient } from 'helpers/restclient';

export default class AffiliatePartnersService {
	static instance = new AffiliatePartnersService();

	_endpoints = {
		getPartner: '/api/affiliate_partners',
	};

	constructor() {
		this.restClient = withCookiesRestClient;
	}

	getPartner = (code) => {
		const endpoint = `${this._endpoints.getPartner}/${code}`;
		return this.restClient.get(endpoint);
	};
}
